import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { testimonials } from '../data/copy';
export function TestimonialsSection() {
  return <section className="defer-paint w-full bg-ink py-10 sm:py-14" aria-labelledby="testimonials-heading" data-id="element-226" data-mp="1n0ae5ipn6ux5">
      <div className="mx-auto max-w-6xl px-6" data-id="element-227" data-mp="1r142ueawsdr3">
        <SectionHeading title={<span id="testimonials-heading" data-id="element-229" data-mp="1qz9ip27gopo2">What volleyball coaches are saying</span>} data-id="element-228" data-mp="1qzt0mix43e23" />

        <ul className="mt-10 grid gap-4 md:grid-cols-3 md:gap-5" data-id="element-230" data-mp="1d3xnyutb2z75">
          {testimonials.map((testimonial, index) => <li key={`${testimonial.role}-${index}`} className="flex flex-col rounded-3xl border border-line bg-navy p-6 sm:p-7" data-id="element-231" data-mp="1hyl2q1yicf8j" data-mpi={index}>
              <QuoteIcon className="h-7 w-7 text-accent" strokeWidth={1.8} aria-hidden="true" data-id="element-232" data-mp="18289142yq1ds" />
              <blockquote className="mt-4 text-lg leading-relaxed text-fg" data-id="element-233" data-mp="2yenzogwxaya0">
                “{testimonial.quote}”
              </blockquote>
              <div className="mt-auto pt-6" data-id="element-234" data-mp="32g98nr6c6sex">
                <p className="border-t border-line pt-5 font-display text-lg font-bold uppercase tracking-wide text-fg" data-id="element-235" data-mp="2v1koae85lrr0">
                  {testimonial.role}
                </p>
                <p className="mt-0.5 text-sm text-muted" data-id="element-236" data-mp="2q0eued2rbyfw">{testimonial.country}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}